import {CountPayload} from "interfaces";
import {Apps} from "enums";

export const toCount = (count: number | CountPayload) => {
    return typeof count === 'number' ? {allTime: count, current: count} : count
}

export const toDate = (date: string = '', app: Apps) => {
    if (date) {
        const dateObj = new Date(date);
        return new Date(!dateObj && (app === Apps.Instinct && date[date.length - 1] !== 'Z') ? `${date}Z` : date)
    }

    return undefined
};